import React from "react"
import styles from "./styles.module.scss"

const NAV_ITEMS = [
  {
    title: "For Candidates",
    navItems: [
      { label: "Find a job", url: "/jobs" },
      { label: "Submit your resume", url: "/candidate" },
    ],
  },
  {
    title: "For Employers",
    navItems: [
      { label: "Talent Search", url: "/client#talentSearchFeature" },
      {
        label: "Payroll Managed Services",
        url: "/client#payrollManagementFeature",
      },
      {
        label: "Work Pass Management",
        url: "/client#workPassManagementFeature",
      },
    ],
  },
  {
    title: "Legals",
    navItems: [
      { label: "Privacy Policy", url: "/privacy-policy" },
      { label: "Terms of Service", url: "/tos" },
    ],
  },
  {
    title: "Contacts",
    description: "Feel free to connect with us via call or drop us a note",
    labelItems: [
      { label: "+65 6339 7198", url: "tel:+65 6339 7198" },
      { label: "info@jobline.com.sg", url: "mailto: info@jobline.com.sg" },
    ],
  },
]

const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.row}>
          <div className={styles.company}>
            <h2>Jobline Resources</h2>
            <p>A platform where talent meets passion</p>
            <p>
              Registration Number: 200307890N
              <br />
              License Number: 12C6060
            </p>
          </div>

          <div className={styles["nav-items"]}>
            {NAV_ITEMS.map(({ title, navItems, description, labelItems }) => {
              return (
                <div key={title} className={styles["nav-column"]}>
                  <h3>{title}</h3>
                  <p>{description}</p>

                  {navItems && (
                    <ul>
                      {navItems.map(({ label, url }) => {
                        return (
                          <li key={label}>
                            <a href={url}>{label}</a>
                          </li>
                        )
                      })}
                    </ul>
                  )}

                  {labelItems && (
                    <ul>
                      {labelItems.map(({ label, url }) => {
                        return (
                          <li key={label}>
                            <a href={url}>{label}</a>
                          </li>
                        )
                      })}
                    </ul>
                  )}
                </div>
              )
            })}
          </div>
        </div>

        <div className={styles.row}>
          <p className={styles.copyright}>
            Copyright © 2009-{new Date().getFullYear()} Jobline Resources Pte
            Ltd
          </p>

          <div className={styles.social}></div>
        </div>
      </div>
    </div>
  )
}

export default Footer
